module.exports = __webpack_public_path__ + "img/unfinish.9334cb7a.svg";